import React from 'react';

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';

export const DialogBoxComponent = (props) => {
  const {
    open,
    handleClose,
    title,
    confirmText,
    cancelText,
    content,
    onConfirm,
    onCancel,
    icon,
    component,
    fullWidth,
    maxWidth,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title || icon ? (
        <DialogTitle
          sx={{ display: 'flex', justifyContent: 'center' }}
          id="alert-dialog-title"
        >
          {icon}
          {title}
        </DialogTitle>
      ) : null}

      {content ? (
        <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
          <DialogContentText
            sx={{ margin: 1 }}
            id="alert-dialog-slide-description"
          >
            {content}
          </DialogContentText>
        </DialogContent>
      ) : null}
      {component && component}

      {onConfirm && onCancel ? (
        <DialogActions sx={{ mx: 2, pb: 2, justifyContent: 'space-between' }}>
          <Button
            hidden={!cancelText}
            variant="outlined"
            onClick={onCancel}
            color="error"
            autoFocus
          >
            {cancelText}
          </Button>
          <Button variant="contained" onClick={onConfirm} color="primary">
            {confirmText}
          </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
